import { Status } from './Constants';

const statusClasses = (originalStatus) => {
  if (!originalStatus) {
    return null;
  }
  const status = originalStatus.toUpperCase();

  return {
    'bg-primary': [Status.PENDING, Status.OPEN, Status.STARTING, Status.SCHEDULED_BY_PERIOD, Status.MANUAL].includes(status),
    'bg-danger': [Status.DECLINED, Status.INVALID, Status.BLOCKED, Status.UNAVAILABLE, Status.FAILED, Status.DISABLED, Status.CRITICAL, Status.DELETED, Status.REJECTED_REFUND].includes(
      status
    ),
    'bg-success': [
      Status.SETTLED,
      Status.CAPTURED,
      Status.COMPLETED,
      Status.VALIDATED,
      Status.CLEARED,
      Status.OK,
      Status.CASH_IN,
      Status.READY,
      Status.ACTIVE,
      Status.ENABLED,
      Status.RESOLVED,
      Status.INTEGRATION_APPROVED,
      Status.ACCEPTED,
      Status.MERCHANT_ACCEPTED,
      Status.DEPOSIT,
      Status.COMPLETED_REFUND,
    ].includes(status),
    'bg-secondary': [Status.BLACKLISTED].includes(status),
    'bg-warning': [
      Status.WARNING,
      Status.REJECTED,
      Status.IN_PROGRESS,
      Status.INTEGRATING,
      Status.PROCESSING,
      Status.EXPIRED,
      Status.UNMATCHED,
      Status.UPLOADED,
      Status.ANONYMOUS,
      Status.PARTIALLY_COMPLETED,
      Status.PENDING_REFUND,
    ].includes(status),
    'bg-gray-500': [Status.TO_RELEASE, Status.GREYLISTED, Status.ON_HOLD, Status.SYSTEM, Status.INACTIVE, Status.TERMINATED].includes(status),
    'bg-light-danger': [Status.CANCELLED, Status.CASH_OUT, Status.CLOSED, Status.ERROR, Status.SUSPENDED, Status.MERCHANT_DISCARDED].includes(status),
    'bg-purple': [Status.SCHEDULED_BY_AMOUNT, Status.FOR_REVIEW, Status.LIVE_REQUESTED, Status.INCORRECT_DETAILS, Status.REFUNDED, Status.WAITING_TRANSFER, Status.TO_REVIEW].includes(status),
    'bg-info': [Status.APPROVED, Status.DELIVERED, Status.CONFIRMED].includes(status),
    'bg-blue-200': [Status.CREATED, Status.WHITELISTED_BASIC].includes(status),
    'bg-blue-300': [Status.INITIATED, Status.WHITELISTED_FULL].includes(status),
    'bg-blue-400': [Status.NEXT_RELEASE, Status.PROCESSING_PAYMENT].includes(status),
    'bg-light-info': [Status.EARLY_RELEASE, Status.SETTLEMENT_BY_BUSINESS_DAYS].includes(status),
    'bg-red-800': [Status.OBSERVED].includes(status),
    'bg-green-100': [Status.RELEASED, Status.PAID].includes(status),
  };
};

export const getStatusOptions = (status, optionsObject) => {
  return optionsObject.filter((option) => {
    return status.includes(option.value);
  });
};

export default statusClasses;
